export const TOGGLE_REDESIGN = 'TOGGLE_REDESIGN' as const

export const toggleRedesign = (value: boolean) => ({
  type: TOGGLE_REDESIGN,
  value,
})
